import { Dialog, DialogActions, DialogContent, DialogTitle, Paper, Button, List, TextField, Checkbox, ListItem, ListItemText, Divider, CircularProgress, Chip } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useState } from 'react';
import { globalGetService } from '../../globalServices';
import { checkApiStatus } from '../utils_v2';
import { trackActivity } from '../../utils/mixpanel';

const LinkingPopup = ({ placeholder, url, toggleModalFn, title, linkUnlink, circularloader, description, isSvEvents, isEngine, isApu }) => {

  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState([]);
  const [listing , SetListing] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getPopupList();
  },[])

   const getPopupList = () => {
          globalGetService(url)
              .then(response => {
                  if (checkApiStatus(response)) {
                      SetListing(response?.data)
                  }
              })
      }

  const handleToggle = (value) => {
  const currentIndex = checked.indexOf(value.id);
  const newChecked = [...checked];

  if (currentIndex === -1) {
    newChecked.push(value.id);
  } else {
    newChecked.splice(currentIndex, 1);
  }

  setChecked(newChecked);
};

  return (
    <Dialog className='console-management-modal' maxWidth="md" style={{ maxHeight: "600px" }} open={true}>
      <DialogTitle>Link {title}</DialogTitle>
      <DialogContent dividers style={{ width: "500px", paddingTop:"0px" }}>
        <div style={{position:"sticky",top:"0", zIndex:"1",background: '#fff', padding: '12px'}}>
          <Paper>
            <TextField
              fullWidth
              placeholder={placeholder || "Search..."}
              variant='outlined'
              size='small'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Paper>
        </div>
          <List>
          {listing?.data?.length && (listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).length === 0 ? (
              <p style={{textAlign:"center"}}>No results found</p>
            )
            :
            ((listing?.data || []).filter(entry => entry?.name?.toLowerCase().includes(search.toLowerCase())).map((entry, index) => (
              <React.Fragment key={index}>
                <ListItem button onClick={() => handleToggle(entry)} dense>
                  <Checkbox
                    edge="start"
                    checked={checked.includes(entry.id)}
                    tabIndex={-1}
                    disableRipple
                    color="primary"
                  />
                  <ListItemText primary={entry.name} />
                   {isSvEvents || isEngine || isApu ? <Chip variant="outlined" size="small" label={entry?.asset_type?.label} style={{fontSize:"12px", maxWidth:"150px" }} /> : null}
                </ListItem>
                <Divider />
              </React.Fragment>
            ))
            )}
        </List>
          <p>{!listing?.data?.length ? <div style={{textAlign:"center"}}>{description}</div> : null}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types View Page', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${title} Linking Modal` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
        <Button variant="contained" size='small'
          onClick={() => {
            linkUnlink('link', checked);
            trackActivity('Console Management', {
              page_title: 'Config Data : Aircraft Types View Page',
              item_type: 'Linked Button',
              event_type: 'Item Clicked',
              event_desc: `Clicked on link Button from ${title} Linking Modal`
            });
          }}
          disabled={isLoading || !checked.length} color="primary" >
           {circularloader ? <CircularProgress size={20} /> : 'Link'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LinkingPopup